// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// icons
import CheckIcon from 'assets/icon/check-icon/CheckIcon';
import CloseIcon from 'assets/icon/close-icon/CloseIcon';
// consts
import { COLORS } from 'app/config/colors';

function ChangeStatusButton(props) {
  const { entity, onChangeStatus, disabled, isActive } = props;

  const icon = isActive ? <CloseIcon /> : <CheckIcon />;

  return (
    <DefaultButton
      color={COLORS.ACCENTUATED_VARIANT}
      colorHover={COLORS.WHITE_VARIANT}
      backgroundColor={COLORS.WHITE_VARIANT}
      backgroundColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
      borderColor={COLORS.SECONDARY_VARIANT}
      borderColorHover={COLORS.SECONDARY_VARIANT}
      onClick={onChangeStatus(entity)}
      icon={icon}
      iconHover={icon}
      size='medium'
      disabled={disabled}
    />
  );
}

ChangeStatusButton.defaultProps = {
  isActive: true,
  disabled: false,
  onChangeStatus: () => {}
};

ChangeStatusButton.propTypes = {
  entity: PropTypes.object,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  onChangeStatus: PropTypes.func
};

export default ChangeStatusButton;
